import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Popover, Button } from 'antd';
import { SortAscendingOutlined } from '@ant-design/icons';

import SortingTable from './SortingTable';

class SortingTableDesktop extends React.Component {

  render() {
    const { table, sortFields } = this.props
    return (
      <BrowserView>
        <Button.Group className='ant-btn-group-fullwidth'>
          <Popover placement="bottom" content={<SortingTable fetch={this.props.fetch} table={table} sortFields={sortFields}/>} trigger="click">
            <Button block className='btn-border-radius'><SortAscendingOutlined /> Urutkan</Button>
          </Popover>
        </Button.Group>
      </BrowserView>
    )
  }
}

export default SortingTableDesktop
